/**
 * slider.js.
 *
 * UI controls for the slider block
 */
(function($) {

	$slider_block = $('.wp-block-media-text .gallery-images');
	
	$slider_block.slick({
		slidesToShow: 1,
		arrows: true,
		dots: true,
		appendArrows: '.wp-block-media-text .gallery-navigation',
		appendDots: '.wp-block-media-text .gallery-navigation',
		asNavFor: '.wp-block-media-text .gallery-descriptions',
		autoplay: true,
  	autoplaySpeed: 6000,
  	// adaptiveHeight: true 
	});

	$gallery_desc = $('.wp-block-media-text .gallery-descriptions');

	$gallery_desc.slick({
		slidesToShow: 1,
		arrows: false,
		dots: false,
		asNavFor: '.wp-block-media-text .gallery-images',
		autoplay: true,
  	autoplaySpeed: 6000,
  // 	adaptiveHeight: true 
	});

})(jQuery);